import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './layout/Layout';
import Home from './pages/Home';
import NoPage from './pages/NoPage';
import Login from './auth/forms/Login';
import Register from './auth/forms/Register';
import ForgotPassword from './auth/forms/ForgotPassword';
import OTPVerification from './auth/forms/OTPVerification';
import ChangePassword from './auth/forms/ChangePassword';
import PasswordReset from './auth/forms/PasswordReset';
import AuthProvider from './auth/AuthContext';
import ReportProvider from './reports/ReportContext';
import ReportIssue from './reports/forms/ReportIssue';
import Dashboard from './dashboard/Dashboard';
import Reports from './reports/Reports';
import Issues from './reports/issues/Issues';
// import IssueView from './issues/IssueView';
import SingleReportView from './reports/SingleReportView';
import SingleIssueView from './reports/issues/SingleIssueView';
import IssuesAssigned from './reports/issues/IssuesAssigned';
import MyIssues from './reports/issues/MyIssues';
import ProposedSolutions from './reports/solutions/ProposedSolutions';
import ReviewProvider from './reviews/ReviewContext';
import Reviews from './reviews/Reviews';
import MyReviews from './reviews/MyReviews';
import AddReview from './reviews/forms/AddReview';
// import EventsProvider from './events/EventsContext';
// import EventDetailPage from './events/EventDetailPage';
// import EventsPage from './events/EventsPage';
// import AddEventDashboard from './events/forms/AddEventDashboard';
// import EditEventPage from './events/forms/EditEventPage';
// import GalleryUploadForm from './events/forms/GalleryUploadForm';
// import MyEvents from './events/MyEvents';
// import MyParticipations from './events/MyParticipations';
// import EventAttendanceMarker from './events/forms/EventAttendanceMarker';
import Profile from './profile/Profile';
import AllAdmins from './profile/AllAdmins'
import AdminRegistration from './profile/forms/AdminRegistration';
import { PrivacyPolicy } from './documents/PrivacyPolicy';
import { TermsAndConditions } from './documents/TermsAndConditions';
import ContactUsSection from './contact/ContactUsSection';
import ContactProvider from './contact/ContactContext';
import Contacts from './contact/Contacts';
import UserManagement from './auth/UserManagement';
import { StatsProvider } from './stats/StatsContext';
import TestForm from './test/TestForm';


export default function App() {
  return (
    <BrowserRouter>
    <StatsProvider>
    <AuthProvider>
      <ReportProvider>
        <ReviewProvider>
          {/* <EventsProvider> */}
            <ContactProvider>            
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="*" element={<NoPage />} />

          <Route path="test" element={<TestForm />} />

          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="/:userId/verification" element={<OTPVerification />} />
          <Route path="password/change" element={<ChangePassword />} />
          <Route path="password/reset/:userId" element={<PasswordReset />} />
          

          <Route path="register-specialist" element={<AdminRegistration />} />


          <Route path="report" element={<ReportIssue />} />
          <Route path="reports/:type" element={<Reports />} />
          <Route path="reports/:reportId/details" element={<SingleReportView />} />


          <Route path="issues" element={<Issues />} />
          <Route path="issues/:issueId" element={<SingleIssueView />} />
          <Route path="issues/assigned" element={<IssuesAssigned />} />
          <Route path="my-issues" element={<MyIssues />} />
          <Route path="/issues/solutions" element={<ProposedSolutions />} />


          <Route path="dashboard" element={<Dashboard />} />

          <Route path="reviews/add/:issueId" element={<AddReview />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="my-reviews" element={<MyReviews />} />

          {/* ENENT MODULE REMOVED */}

          {/* <Route path="events" element={<EventsPage />} />
          <Route path="events/add" element={<AddEventDashboard />} />
          <Route path="events/:eventId" element={<EventDetailPage />} />
          <Route path="events/:eventId/edit" element={<EditEventPage />} />
          <Route path="events/:eventId/gallery-upload" element={<GalleryUploadForm />} />

          <Route path="events/my-events" element={<MyEvents />} />
          <Route path="events/my-participations" element={<MyParticipations />} />
          <Route path="events/:eventId/attend" element={<EventAttendanceMarker />} /> */}



          <Route path="profile" element={<Profile/>} />
          <Route path="admin-users" element={<AllAdmins/>} />

          
          <Route path="privacy" element={<PrivacyPolicy/>} />
          <Route path="terms" element={<TermsAndConditions/>} />


          <Route path="contact/form" element={<ContactUsSection/>} />
          <Route path="contact" element={<Contacts/>} />


          <Route path="users/management" element={<UserManagement/>} />



        </Route>
      </Routes>
      </ContactProvider>
      {/* </EventsProvider> */}
      </ReviewProvider>
      </ReportProvider>
      </AuthProvider>
      </StatsProvider>
    </BrowserRouter>
  )
}
